module.exports = __webpack_public_path__ + "static/media/anc5kz.01ea2dcd.pdf";